import { css, keyframes } from 'styled-components';
import animationDurationInMS from '../../primitives/duration';
import animationEasingCurves from '../../primitives/easing';
var defaults = {
  duration: animationDurationInMS.faster,
  easing: animationEasingCurves.easeBoth,
  delay: 0,
  iterations: 1,
  direction: 'normal',
  fillMode: 'forwards'
};

var slideKeyframe = function slideKeyframe(_ref) {
  var fromX = _ref.fromX,
      fromY = _ref.fromY,
      toX = _ref.toX,
      toY = _ref.toY;
  return keyframes(["from{transform:translate(", ",", ");}to{transform:translate(", ",", ");}"], fromX, fromY, toX, toY);
};

var slide = function slide(configuration) {
  var _configuration$durati, _configuration$easing, _configuration$delay, _configuration$iterat, _configuration$direct, _configuration$fillMo;

  return css(["", " ", "ms ", " ", "ms ", " ", " ", ""], slideKeyframe(configuration), (_configuration$durati = configuration === null || configuration === void 0 ? void 0 : configuration.duration) !== null && _configuration$durati !== void 0 ? _configuration$durati : defaults.duration, (_configuration$easing = configuration === null || configuration === void 0 ? void 0 : configuration.easing) !== null && _configuration$easing !== void 0 ? _configuration$easing : defaults.easing, (_configuration$delay = configuration === null || configuration === void 0 ? void 0 : configuration.delay) !== null && _configuration$delay !== void 0 ? _configuration$delay : defaults.delay, (_configuration$iterat = configuration === null || configuration === void 0 ? void 0 : configuration.iterations) !== null && _configuration$iterat !== void 0 ? _configuration$iterat : defaults.iterations, (_configuration$direct = configuration === null || configuration === void 0 ? void 0 : configuration.direction) !== null && _configuration$direct !== void 0 ? _configuration$direct : defaults.direction, (_configuration$fillMo = configuration === null || configuration === void 0 ? void 0 : configuration.fillMode) !== null && _configuration$fillMo !== void 0 ? _configuration$fillMo : defaults.fillMode);
};

export default slide;